import { gql } from 'apollo-boost';

const manyQuery = gql`
  query {
    superManagers {
      id
      clubId
      firstName
      lastName
      middleName
      email
      gender
      status
      types
      club {
        id
        shortName
      }
    }
  }
`;

const oneQuery = gql`
  query superManager($id: Int!) {
    superManager(id: $id) {
      id
      clubId
      firstName
      lastName
      middleName
      fullName
      email
      gender
      status
      types
    }
  }
`;

const paginatedSuperManagersQuery = gql`
  query getPaginatedSuperManagers(
    $inputFilter: SuperManagersFilterInputObjectType
  ) {
    paginatedSuperManagers(inputFilter: $inputFilter) {
      items {
        id
        clubId
        firstName
        lastName
        middleName
        email
        gender
        status
        types
        club {
          id
          shortName
        }
      }
      pageInfo {
        total
      }
    }
  }
`;

export const createMutation = gql`
  mutation createSuperManager($inputData: SuperManagerInputType!) {
    createSuperManager(inputData: $inputData) {
      ok
      errors {
        field
        messages
      }
    }
  }
`;

export const updateMutation = gql`
  mutation updateSuperManager($id: Int!, $inputData: SuperManagerInputType!) {
    updateSuperManager(id: $id, inputData: $inputData) {
      ok
      errors {
        field
        messages
      }
    }
  }
`;

export const deleteMutation = gql`
  mutation deleteSuperManager($id: Int!) {
    deleteSuperManager(id: $id) {
      ok
      errors {
        field
        messages
      }
    }
  }
`;

const SUPER_MANAGERS = {
  manyQuery,
  oneQuery,
  createMutation,
  updateMutation,
  deleteMutation,
  paginatedSuperManagersQuery,
};

export default SUPER_MANAGERS;
